import React from "react";
import { Box } from "@mui/material";
import { ActionLogsPanel } from "./ActionLogsPanel";
import { EmailAdminActions } from "./EmailAdminActions";

interface AdminEmailPanelProps {
  emailId?: string;
  messageId?: string;
  inboxEmail?: string;
  sharedInbox?: string;
}

/**
 * Admin-only panel for email operations
 * Contains action logs and admin actions dropdown
 */
export const AdminEmailPanel: React.FC<AdminEmailPanelProps> = ({
  emailId,
  messageId,
  inboxEmail,
  sharedInbox,
}) => {
  return (
    <Box sx={{ mb: 2 }}>
      {/* Admin Actions Dropdown */}
      <EmailAdminActions
        emailId={emailId}
        messageId={messageId}
        inboxEmail={inboxEmail}
        sharedInbox={sharedInbox}
      />

      {/* Action Logs Panel - only show if emailId is available */}
      {emailId && <ActionLogsPanel emailId={emailId} />}
    </Box>
  );
};
